import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers }) => {
    const apiCalls = {
        login(user) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Autenticacao/Autenticar',
                responseType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSS-Protection': '1; mode=block',
                    'X-Content-Type-Options': 'nosniff'
                },
                data: Helpers.aplicarValidacoes(user),                
            });
        },
        inserirUsuario(user) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/InserirUsuario',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(user),
            });
        },
        getUsersExibicao(filters) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/RecuperarUsuariosExibicao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filters),
            });
        },
        getListarUsuarios(){
            return instance({
                method: 'get',
                baseURL,
                url: 'Usuario/ListarUsuarios',
                responseType: 'json',
                headers: headers
            });
        },
        buscarUsuarioId(id) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/BuscarUsuarioId',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'idUsuario': id }),
            });
        },
        atualizarUsuario(usuario, idUserAlteracao) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/EditarUsuario',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'usuario': usuario, 'idUserAlteracao': idUserAlteracao }),
            })
        },
        atualizarSituacao(idUsuario, situacao, idUsuarioAlteracao) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/AtualizarSituacao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'idUsuario':idUsuario, 'situacao':situacao, 'idUsuarioAlteracao':idUsuarioAlteracao })
            });
        },
        atualizarSenha(idUsuario, novaSenha){            
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/AtualizarSenha',
                responseType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSS-Protection': '1; mode=block',
                    'X-Content-Type-Options': 'nosniff',
                    'Content-Security-Policy': "script-src 'self' scripts.apidev.kurierservicos.com.br/kportalcredenciaisdev; media-src 'self'; img src *; default-src 'self' https://*.apidev.kurierservicos.com.br/kportalcredenciaisdev"
                  },
                data: Helpers.aplicarValidacoes({"IdUsuario":idUsuario,"NovaSenha":novaSenha}),
            });
        },        
        esqueciMinhaSenha(login){
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/EsqueciMinhaSenha',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({"login":login}),
            });
        },
        verificarSenhaAtual(idUsuario, senhaAtual){            
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/VerificarSenhaAtual',
                responseType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSS-Protection': '1; mode=block',
                    'X-Content-Type-Options': 'nosniff',
                    'Content-Security-Policy': "script-src 'self' scripts.apidev.kurierservicos.com.br/kportalcredenciaisdev; media-src 'self'; img src *; default-src 'self' https://*.apidev.kurierservicos.com.br/kportalcredenciaisdev"
                  },
                data: Helpers.aplicarValidacoes({"IdUsuario":idUsuario,"SenhaAtual":senhaAtual}),
            });
        },
        atualizarStatusTermoUso(idUsuario, statusTermoUso) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/AtualizarStatusTermoUso',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'idUsuario': idUsuario, 'statusTermoUso': statusTermoUso })
            });
        },
    }
    return apiCalls;
};